<template>
    <div>
        <h1>Aromaten</h1>
        <p>
            Aromaten, auch aromatische Verbindungen genannt, sind eine
            Stoffklasse der organischen Chemie und haben alle einen ihnen
            typischen Geruch. Sie besitzen mindestens ein Ringsystem, das der
            <router-link to="/sonstiges/hueckel">Hückel-Regel</router-link>
            entspricht. Sie sind cyclische Moleküle und besitzen ein
            delokalisiertes Pi-Elektronen-System, das heißt eine Überlappung der
            Pi-Orbitale.
        </p>
        <hr class="chapter-split" />
        <chapter-heading title="Wichtigster Aromat: Benzol"></chapter-heading>
        <p>
            C<sub>6</sub>H<sub>6</sub>, Benzol ist die Stammverbindung der
            aromatischen Kohlenwasserstoffe (Aromaten). Benzol ist der
            Grundbaustein für viele Aromaten und ist eine sehr stabile
            Verbindung -> Reagiert nur unter Einfluss eines Katalysators mit
            Brom. Aufgrund des delokalisierten Pi-Elektronen-Systems wird es oft
            so dargestellt:
        </p>
        <img
            src="@/assets/img/stoffe/aromaten/benzol.png"
            alt="Gängige Darstellung von Benzol"
            title="Gängige Darstellung von Benzol"
        /><br />
        <p>
            Für Reaktionsgleichungen ist jedoch die Nutzung der mesomeren
            Grenzstrukturen einfacher:
        </p>
        <img
            src="@/assets/img/stoffe/aromaten/benzol-mesomer.png"
            alt="Mesomere Grenzstrukturen von Benzol für Reaktionsgleichungen"
            title="Mesomere Grenzstrukturen von Benzol für Reaktionsgleichungen"
            width="250px"
            height="auto"
        />
        <hr class="chapter-split" />
        <chapter-heading title="Reaktionen"></chapter-heading>
        <ul>
            <li>
                Halogenierung mit einem Katalysator (<router-link
                    to="/reaktionen/elektrophile-substitution"
                    >elektrophile Subsitution</router-link
                >)
            </li>
        </ul>
        <hr class="chapter-split" />
        <chapter-heading title="Zusammenfassung"></chapter-heading>
        <table>
            <tr>
                <th>Beschreibung</th>
                <td>
                    <ul>
                        <li>alle Atome des Rings sind sp2-hybridisiert</li>
                        <li>
                            jede aromatische Verbindung hat ihren eigenen
                            typischen Geruch
                        </li>
                        <li>besitzen mindestens ein Ringsystem</li>
                    </ul>
                </td>
            </tr>
            <tr>
                <th>Löslichkeit</th>
                <td>
                    löst sich in fast allen organischen Lösungsmitteln, jedoch
                    kaum in Wasser
                </td>
            </tr>
            <tr>
                <th>Benzol</th>
                <td>Grundbaustein in aromatischen Verbindungen</td>
            </tr>
            <tr>
                <th>Bindungen</th>
                <td>
                    delokalisiertes Pi-Elektronen-System. Vereinfacht: Einfach
                    und Doppelbindungen alternierend
                </td>
            </tr>
        </table>
    </div>
</template>
<script>
import ChapterHeading from '../../components/chapterHeading';
export default {
    components: { ChapterHeading },
};
</script>
